export const BASE_STATIC_URL = '//static.l7dex.com/'
export const STATIC_URL = '//static.l7dex.com/image/'

export const SITE_URL = '//www.l7dex.com/'
export const APP_URL = '//app.l7dex.com/'
